import { GET_LOAN_KYC_REPORT } from "../../../Types";

const LoanKycReportReducer = (state = [], action) => {
  switch (action.type) {
    case GET_LOAN_KYC_REPORT:
      return action.payload;

    default:
      return state;
  }
};
export default LoanKycReportReducer;
